/* NUORO Trustpilot: official TrustBoxes only; no copied score or review count. */
(() => {
  'use strict';
  if (window.NuoroTrustpilot) { window.NuoroTrustpilot.init(); return; }

  const TEMPLATE = '5419b6ffb0d04a076446a9af';
  const BUSINESS = '6659801df278f22f2d471a1d';
  const TOKEN = 'bfe4f589-0dc0-4765-822d-e67a41b7f3c1'; // Public embed token from the existing TrustBox.
  const LINK = 'https://fr.trustpilot.com/review/drinknuoro.com';
  const BOXES = '.nuoro-module .tp-real, .cart__trustpilot, .nuoro-cart-trustpilot, .nuoro-trustpilot';
  const STATIC = '.nuoro-module .hero-rating, .nuoro-module .shop-rating';
  const LEGACY = '.custom-review-widget, .review-custom__badge, .review-slider__badge, .footer__rating-badge';
  const CLAIMS = '.custom-review-widget__message, .review-custom__badge-claims, .review-slider__badge-claims, .footer__rating-badge-claims';
  const states = new Map();
  const initialized = new WeakSet();
  let frame = 0;
  let poll = 0;
  let attempts = 0;

  function all(root, selector) {
    const found = Array.from(root.querySelectorAll(selector));
    if (root.nodeType === 1 && root.matches(selector)) found.unshift(root);
    return found;
  }

  function createWidget() {
    const widget = document.createElement('div');
    widget.className = 'trustpilot-widget';
    const link = document.createElement('a');
    link.href = LINK;
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = 'Lire nos avis sur Trustpilot';
    widget.append(link);
    return widget;
  }

  function createBox() {
    const box = document.createElement('div');
    box.className = 'nuoro-trustpilot';
    return box;
  }

  function hydrate() {
    if (typeof window.Trustpilot?.loadFromElement !== 'function') return false;
    states.forEach(({ widget }) => {
      if (!widget.isConnected || initialized.has(widget)) return;
      try {
        // The global bootstrap may already have mounted this exact TrustBox.
        if (!widget.querySelector('iframe')) window.Trustpilot.loadFromElement(widget, true);
        initialized.add(widget);
      } catch (_) {
        // Keep the real Trustpilot link available if the third-party widget fails.
      }
    });
    return true;
  }

  function awaitLibrary() {
    if (hydrate()) { if (poll) window.clearInterval(poll); poll = 0; return; }
    if (poll || attempts >= 80) return;
    poll = window.setInterval(() => {
      attempts += 1;
      if (hydrate() || attempts >= 80) { window.clearInterval(poll); poll = 0; }
    }, 250);
  }

  function mount(box) {
    const current = states.get(box);
    if (current && current.widget === box.querySelector('.trustpilot-widget')) return;
    if (current) { current.observer?.disconnect(); states.delete(box); }
    let widget = box.querySelector('.trustpilot-widget');
    if (!widget) { widget = createWidget(); box.replaceChildren(widget); }
    box.classList.add('nuoro-trustpilot');
    box.classList.remove('tp-aligned');
    box.removeAttribute('aria-label');
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Avis clients sur Trustpilot');
    widget.dataset.locale = 'fr-FR';
    widget.dataset.templateId = TEMPLATE;
    widget.dataset.businessunitId = BUSINESS;
    widget.dataset.styleWidth = '420px';
    widget.dataset.styleHeight = '28px';
    widget.dataset.token = TOKEN;
    widget.dataset.theme = 'light';
    widget.removeAttribute('aria-label');
    // Remove remaining hard-coded mobile duplicates inside this wrapper.
    box.querySelectorAll('.hero-rating, .shop-rating').forEach(el => el.remove());
    if (!widget.querySelector('iframe, a')) {
      const fallback = createWidget().firstElementChild;
      widget.append(fallback);
    }
    const parent = box.parentElement;
    const resize = () => {
      if (!box.isConnected || !parent) return;
      const container = getComputedStyle(parent).display === 'contents' ? parent.parentElement : parent;
      if (!container) return;
      const style = getComputedStyle(container);
      const available = container.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
      // A hidden drawer will be measured when it opens by ResizeObserver.
      if (available <= 0) return;
      const compactHero = innerWidth < 768 && box.closest('[data-nuoro-module="Hero"]');
      const scale = Math.min(compactHero ? 20 / 28 : 1, available / 420);
      box.style.setProperty('--nuoro-tp-scale', String(scale));
      box.style.setProperty('--nuoro-tp-width', `${420 * scale}px`);
      box.style.setProperty('--nuoro-tp-height', `${28 * scale}px`);
    };
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(resize) : null;
    if (parent) observer?.observe(parent);
    states.set(box, { widget, observer, resize });
    resize();
  }

  function upgradeLegacy(root) {
    all(root, LEGACY).forEach(legacy => {
      if (legacy.dataset.nuoroTrustpilotUpdated === 'true') return;
      // The live rating-stars snippet sometimes wraps the entire block in a link.
      // The official iframe provides its own links, so avoid nested link controls.
      if (legacy.parentElement?.matches('a.custom-review-widget__link')) {
        const oldLink = legacy.parentElement;
        const wrapper = document.createElement('div');
        wrapper.className = oldLink.className;
        oldLink.replaceWith(wrapper);
        wrapper.append(legacy);
      }
      const claims = Array.from(legacy.querySelectorAll(CLAIMS)).filter(claim =>
        !/\d[\d\s.,]*\s*(?:avis\b|\/\s*5\b)/i.test(claim.textContent)
      );
      const box = createBox();
      box.classList.add('nuoro-trustpilot--legacy');
      legacy.replaceChildren(box, ...claims);
      legacy.dataset.nuoroTrustpilotUpdated = 'true';
      legacy.removeAttribute('aria-label');
      mount(box);
    });
  }

  function init(root = document) {
    if (!root.querySelectorAll) return;
    // Desktop and mobile now use the same live widget; there is no static fallback rating.
    all(root, STATIC).forEach(staticRating => {
      const module = staticRating.closest('.nuoro-module');
      if (module?.querySelector('.tp-real, .nuoro-trustpilot')) staticRating.remove();
      else staticRating.replaceWith(createBox());
    });
    upgradeLegacy(root);
    all(root, BOXES).forEach(mount);
    states.forEach((state, box) => {
      if (box.isConnected) return;
      state.observer?.disconnect();
      states.delete(box);
    });
    awaitLibrary();
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(() => { frame = 0; init(); });
  }

  window.NuoroTrustpilot = { init };
  function start() {
    init();
    const selector = `${BOXES}, ${STATIC}, ${LEGACY}`;
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      ) || Array.from(record.removedNodes).some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      ))) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.querySelectorAll('script[src*="widget.trustpilot.com/bootstrap/"]').forEach(script => {
      script.addEventListener('load', () => { attempts = 0; init(); }, { once: true });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('nuoro:trustpilot:ready', () => { attempts = 0; init(); });
  window.addEventListener('resize', () => states.forEach(state => state.resize()), { passive: true });
  window.addEventListener('load', () => { attempts = 0; init(); }, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
